import React from "react";
import whatsAppIcone from "../assets/icons/whatsapp-svgrepo-com (2).svg";


const ServiceCard = ({
  bannerImage,
  serviceTitle,
  serviceDescription,
  branches // Un tableau d'objets { title, description }
}) => {
  const onSubmit = (service) => {
    const msg = `Hello, ce service ${service} m'intéresse. Pourrais-je avoir plus d'information si vous plait ? `;
    // const phoneWithCountryCode = "+1234567890"; // Ensure the phone number includes the country code
    if (msg) {
      const url = `https://wa.me/${"+2250585569842"}?text=${encodeURIComponent(
        msg
      )}`;
      window.open(url, "_blank");
    } else {
      alert("Please insert message to send");
    }
  };

  return (
    <section
      id="features"
      class="container mx-auto px-4 space-y-6 bg-slate-50 py-8 md:py-12 lg:py-20"
    >
      <div class="mx-auto flex max-w-[58rem] flex-col items-center space-y-4 text-center">
        <h2 class="font-bold text-3xl leading-[1.1] sm:text-3xl md:text-6xl">
          {serviceTitle}
        </h2>

        <p class="max-w-[85%] leading-normal text-muted-foreground sm:text-lg sm:leading-7">
          {serviceDescription}
        </p>
      </div>

      <div class="mx-auto grid justify-center gap-4 sm:grid-cols-2 md:max-w-[64rem] md:grid-cols-3">
        {branches.map((branch, index) => (
          <div
            key={index}
            class="relative overflow-hidden rounded-lg border cursor-pointer bg-white select-none hover:shadow hover:shadow-teal-200 p-2"
          >
            <div class="flex flex-col justify-between rounded-md p-2">
              <img
                src={branch.image}
                className="h-[250px] w-full rounded-xl "
                alt=""
              />

              <div class="space-y-2 my-5">
                <h3 class="font-bold">{branch.title}</h3>
                <p class="text-sm text-muted-foreground">
                  {branch.description}
                </p>
              </div>
              <div onClick={()=>{
                onSubmit(branch.title)
              }} className="flex items-center mt-6 w-full justify-center">
                <span className=" flex  gap-x-3  rounded-full bg-primary px-6 py-2.5 text-sm text-center font-bold text-white transition  md:mr-6 lg:mr-8">
                  <img
                    src={whatsAppIcone}
                    className="w-5 border-transparent"
                    alt=""
                  />
                  En savoir plus
                </span>
              </div>
            
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceCard;
